import Immutable from 'immutable';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

// action creators
import { appointmentListClear, appointmentListFetch } from '../../../actions/appointmentActions';
import { doctorAvailabilitiesFetch, doctorListFetch } from '../../../actions/doctorActions';

// components
import Caption from './_Caption';
import Day from './_Day';
import Navbar from './_Navbar';
import DayPicker from 'react-day-picker';
import Weekday from './_Weekday';

class Calendar extends React.Component {
  static propTypes = {
    appointment:                PropTypes.instanceOf(Immutable.Map),
    clearAppointments:          PropTypes.func.isRequired,
    fetchAppointmentList:       PropTypes.func.isRequired,
    fetchDoctorAvailabilities:  PropTypes.func.isRequired,
    fetchDoctorList:            PropTypes.func.isRequired
  };

  componentWillMount() {
    const now = moment();

    this._initAppointmentList(now);
    this._initDoctorAvailability(now);
    this._initDoctorList();
  }

  componentWillUnmount() {
    const { clearAppointments } = this.props;

    clearAppointments();
  }

  render() {
    return (
      <DayPicker captionElement={ <Caption /> }
        className='calendar'
        modifiers={ { weekend: this._isWeekend } }
        navbarElement={ <Navbar /> }
        onMonthChange={ this._handleMonthChange }
        renderDay={ this._renderDay }
        weekdayElement={ <Weekday /> } />
    );
  }

  // private

  _handleMonthChange  = this._handleMonthChange.bind(this);
  _renderDay          = this._renderDay.bind(this);

  _handleMonthChange(date) {
    this._initAppointmentList(date);
    this._initDoctorAvailability(date);
  }

  _initAppointmentList(date) {
    const { appointment, fetchAppointmentList } = this.props;

    let startDate;
    let endDate;

    if (!appointment.get('data')) {
      startDate = moment(date).startOf('quarter');
      endDate   = moment(date).startOf('quarter').add(1, 'year');
    } else {
      startDate = moment(date).startOf('month');
      endDate   = moment(date).endOf('month');
    }

    const params = {
      'start_date': startDate.format(),
      'end_date':   endDate.format(),
      'status[]':   ['opened', 'booked', 'closed', 'confirmed']
    };

    fetchAppointmentList(params);
  }

  _initDoctorAvailability(date) {
    const { fetchDoctorAvailabilities } = this.props;

    const startDate = moment(date).startOf('month');
    const endDate   = moment(date).endOf('month');

    const params = {
      'start_date': startDate.format(),
      'end_date':   endDate.format()
    };

    fetchDoctorAvailabilities(params);
  }

  _initDoctorList() {
    const { fetchDoctorList } = this.props;

    fetchDoctorList();
  }

  _isWeekend(day) {
    const dayMoment = moment(day);
    const dayOfWeek = dayMoment.day();

    return (dayOfWeek === 0 || dayOfWeek === 6);
  }

  _renderDay(day) {
    return <Day date={ moment(day) } />;
  }
}

const mapStateToProps = (state) => {
  return {
    appointment: state.get('appointment')
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    clearAppointments: () => {
      dispatch(appointmentListClear());
    },

    fetchAppointmentList: (params) => {
      dispatch(appointmentListFetch(params));
    },

    fetchDoctorAvailabilities: (params) => {
      dispatch(doctorAvailabilitiesFetch(params));
    },

    fetchDoctorList: () => {
      dispatch(doctorListFetch());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Calendar);



// WEBPACK FOOTER //
// ./app/components/managers/calendar/_Calendar.jsx